import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import {
  observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import classes from './GeneralSearchComponent.module.scss';

interface IProps {
  searchBy: string;
  onSearchClick: any;
  placeHolder?: string;
  onClearSearch?: () => void;
}

interface IState {
  title: string;
  isSearching: boolean;
}

@observer
class GeneralSearchComponent extends Component<IProps, IState> {
  filteredData: any[] = [];

  constructor(props: IProps, state: IState) {
    super(props);
    state = {
      title: '',
      isSearching: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.setState({
      title: '',
    });
  }

  handleTextChange = (text: string) => {
    this.setState({
      title: text,
    });
  };

  handleSearch = async () => {
    if (this.state.title) {
      this.setState({
        isSearching: true,
      });
      await this.props.onSearchClick(this.state.title, this.state.isSearching);
    }
  };

  handleClear = async () => {
    if (this.state.isSearching && this.props.onClearSearch) {
      this.props.onClearSearch();
    }
    this.setState({
      title: '',
      isSearching: false,
    });
  };

  render() {
    return (
      <Paper className={classes.container} elevation={1}>
        <TextField
          className={classes.input}
          placeholder={this.props.placeHolder ? this.props.placeHolder : 'Search'}
          value={this.state.title}
          label={this.props.placeHolder ? this.props.placeHolder : 'Search'}
          onKeyPress={(event: any) => {
            if (event.key === 'Enter') {
              this.handleSearch();
            }
          }}
          onChange={(text) => {
            this.handleTextChange(text.target.value);
          }}
          InputProps={{
            endAdornment: this.state.title ? (
              <IconButton
                aria-label="close"
                onClick={() => this.handleClear()}
              >
                <CloseIcon />
              </IconButton>
            ) : null,
          }}
        />
        <IconButton
          className={classes.iconButton}
          aria-label="search"
          onClick={() => this.handleSearch()}
        >
          <SearchIcon />
        </IconButton>
      </Paper>
    );
  }
}

export default GeneralSearchComponent;
